import { render, staticRenderFns } from "./CustomSimpleTable.vue?vue&type=template&id=5e3f6da7&"
import script from "./CustomSimpleTable.vue?vue&type=script&lang=js&"
export * from "./CustomSimpleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports